<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-form @submit.prevent="copy">
        <q-card-section>
          <div class="text-h6">Копировать выбранные проекты в</div>
          <select-project-type v-model="selectedProject"/>
        </q-card-section>
        <q-card-section v-if="selectedProject">
          <q-input v-model="startTime" label="Дата начала">
            <template v-slot:prepend>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="startTime" mask="YYYY-MM-DD HH:mm">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>

            <template v-slot:append>
              <q-icon name="access_time" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-time v-model="startTime" mask="YYYY-MM-DD HH:mm" format24h>
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                    </div>
                  </q-time>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
          <q-input v-model="executionTime" label="Дата выполнения">
            <template v-slot:prepend>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="executionTime" mask="YYYY-MM-DD HH:mm">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>

            <template v-slot:append>
              <q-icon name="access_time" class="cursor-pointer">
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-time v-model="executionTime" mask="YYYY-MM-DD HH:mm" format24h>
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Закрыть" color="primary" flat/>
                    </div>
                  </q-time>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>

          <q-select use-chips multiple v-model="performers" clearable :loading="isUserLoading"
                    :options="users" :option-label="(user: ProjectUser) => `${user.username} (${user.email})`"
                    option-value="email" label="Исполнители" emit-value behavior="menu" map-options/>
        </q-card-section>
        <q-card-actions align="right">
          <q-btn :disable="!selectedProject" :loading="copied" no-caps label="Скопировать" type="submit"
                 color="primary"/>
          <q-btn :disable="copied" color="primary" label="Отмена" no-caps @click="onDialogCancel"/>
        </q-card-actions>
      </q-form>

    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import {useDialogPluginComponent} from 'quasar'
import {useUsers} from '../composables/project'
import {useCopyProject} from '../composables/task'
import {ref, toRefs} from 'vue'
import {useDayJs} from '../composables/dayjs';
import {ProjectUser} from '../models/project';
import SelectProjectType from "./SelectProjectType.vue";

const dayjs = useDayJs()

const props = withDefaults(defineProps<{
  projects: number[],
}>(), {projects: () => []})

const {projects} = toRefs(props)
defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])

const selectedProject = ref<number | null>(null)


const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

const {data: users, isFetching: isUserLoading} = useUsers()
const executionTime = ref(null)
const performers = ref<string[]>([])
const copied = ref(false)
const startTime = ref(null)

async function copy() {
  copied.value = true
  const selectedProjectId = selectedProject.value
  if (!selectedProjectId) {
    copied.value = false
    return
  }
  const copiedProjects = projects.value
  const body = {
    startTime: startTime.value ? dayjs(startTime.value).utc().format() : null,
    executionTime: executionTime.value ? dayjs(executionTime.value).utc().format() : null,
    assigned: performers.value,
  };
  if (copiedProjects.length > 0) {
    await useCopyProject(
        selectedProjectId,
        copiedProjects,
        body
    )
  }
  copied.value = false
  onDialogOK()
}
</script>
